<div class="h-100 w-100">
  @if (routeQualifications.length === 0) {
    <div class="empty-state-container">
      <nz-empty
        [nzNotFoundContent]="
          'qualifications.route_knowledge_map.no_routes' | translate
        "
      ></nz-empty>
    </div>
  } @else {
    <div>
      @if (selectedRouteQualification) {
        <div>
          {{ selectedRouteQualification.name }} |
          {{ 'general.valid_until' | translate }}:
          {{
            selectedRouteQualification | userQualificationV2TransformValidTill
          }}
        </div>
      } @else {
        {{ 'qualifications.route_knowledge_map.cta' | translate }}
      }
    </div>
    <div id="map" class="map"></div>
  }
</div>
